// extracted by mini-css-extract-plugin
export var description = "FeatureBlockCompact-module--description--fefbc";
export var dimmed = "FeatureBlockCompact-module--dimmed--97043";
export var title = "FeatureBlockCompact-module--title--03052";